import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  createBaseSelector,
  registerSlice,
  StatusType
} from '@shared/lib/redux'

import { SessionModel } from '../domain/session.model'
import { Credencials } from '../type'

export interface SessionStore {
  session: SessionModel
  status: StatusType
  error: string | null
}

const initialState: SessionStore = {
  session: new SessionModel(null),
  status: 'idle',
  error: null
}

const sessionSlice = createSlice({
  name: 'sessionSlice',
  initialState,
  reducers: {
    createSessionStart(state, _action: PayloadAction<Credencials>) {
      state.status = 'loading'
    },
    createSessionSuccess(state, action: PayloadAction<SessionModel>) {
      state.session = action.payload
      state.status = 'success'
      state.error = null
    },
    createSessionFailure(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.status = 'error'
    },
    updateSessionStart(state) {
      state.status = 'fetching'
    },
    updateSessionSuccess(state, action: PayloadAction<SessionModel>) {
      state.session = action.payload
      state.status = 'success'
      state.error = null
    },
    updateSessionFailure(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.status = 'error'
    },
    updateSessionCanceled(state) {
      state.error = null
      state.status = 'error'
      state.session = new SessionModel(null)
    },
    setSession: (state, action: PayloadAction<SessionModel>) => {
      state.session = action.payload
      state.error = null
    },
    removeSessionStart(state) {
      state.status = 'fetching'
    },
    removeSessionSuccess(state) {
      state.session = new SessionModel(null)
      state.status = 'success'
      state.error = null
    },
    removeSessionFailure(state, action: PayloadAction<string>) {
      state.session = new SessionModel(action.payload)
      state.status = 'error'
    }
  }
})
const sessionBaseSelector = createBaseSelector(sessionSlice)
registerSlice([sessionSlice])

const selectSession = createSelector(sessionBaseSelector, (s) => {
  return {
    isAuthorized: s.session.isActive(),
    session: s.session,
    status: s.status,
    error: s.error
  }
})

const selectStatus = createSelector(sessionBaseSelector, (s) => {
  return {
    status: s.status,
    error: s.error
  }
})

export const sessionStore = {
  actions: { ...sessionSlice.actions },
  selectors: {
    selectSession,
    selectStatus
  },
  name: sessionSlice.name
}
